import { ffServicesApiUrl } from '~/js/templates/index/helpers'
import axios from 'axios'

export const defaultAggregations = {
  productTypes: [],
  tasteTags: [],
  colorTags: [],
  facetTags: [],
  priceRange: { min: 0, max: 500000 },
}

const acceptedColors = [
  'MULTI',
  'ホワイト',
  'ブラック',
  'グレー',
  'ブラウン',
  'ベージュ',
  'グリーン',
  'ブルー',
  'パープル',
  'イエロー',
  'ピンク',
  'レッド',
  'オレンジ',
  'シルバー',
  'ゴールド',
]

const formatProduct = (product = {}) => {
  const variants = Array.isArray(product.variants) ? product.variants : []

  return {
    ...product,
    variants: variants.map((variant) => ({
      ...variant,
      available: !!variant.availableForSale,
      inventory_management: 'shopify',
    })),
  }
}

export const searchProducts = async (searchParameters) => {
  const {
    collectionId = undefined,
    keyword = '',
    onlyInStock = false,
    productTypes = [],
    priceRange = { min: '', max: '' },
    tagsSet = {},
    sortBy = 'relevance',
    page = 1,
    limit = 48,
  } = searchParameters

  const minPrice =
    priceRange.min === '' || priceRange.min === null || priceRange.min === undefined
      ? undefined
      : Number.isFinite(Number(priceRange.min))
        ? Number(priceRange.min)
        : undefined
  const maxPrice =
    priceRange.max === '' || priceRange.max === null || priceRange.max === undefined
      ? undefined
      : Number.isFinite(Number(priceRange.max))
        ? Number(priceRange.max)
        : undefined

  try {
    /**
     * "|" はOR条件、"," はAND条件を表す
     * 例）tagA|tagB,tagC|tagD,tagE|tagF
     *    => (tagA OR tagB) AND (tagC OR tagD) AND (tagE OR tagF)
     */
    const tags = Object.values(tagsSet)
      .filter((tags) => tags.length > 0)
      .map((tags) => tags.join('|'))
      .join(',')

    const { data: result } = await axios.get(
      `${ffServicesApiUrl}/store-search/products`,
      {
        params: {
          keyword,
          only_in_stock: onlyInStock,
          collection_id: collectionId,
          product_types: productTypes.join(','),
          min_price: minPrice,
          max_price: maxPrice,
          tags,
          sort_by: sortBy,
          page,
          limit,
        },
      }
    )

    const productTypesBuckets = (
      result?.aggregations?.product_types?.buckets || []
    )
      .filter((b) => b.key.includes('廃番'))
      .map((b) => ({
        label: b.key.replace('廃番（', '').replace('）', ''),
        value: b.key,
        count: b.doc_count,
      }))

    const tasteTagsBuckets = (
      result?.aggregations?.taste_tags?.buckets || []
    ).map((b) => ({
      label: b.key,
      value: b.key,
      count: b.doc_count,
    }))

    const colorTagsBuckets = (result?.aggregations?.color_tags?.buckets || [])
      .map((b) => ({
        label: b.key.replace('カラー:', '').toUpperCase(),
        value: b.key,
        count: b.doc_count,
      }))
      .filter((b) => acceptedColors.includes(b.label))

    const facetTagsBuckets = (
      result?.aggregations?.facet_tags?.buckets || []
    ).map((b) => ({
      label: b.key.replace('facet:', ''),
      value: b.key,
      count: b.doc_count,
    }))

    const priceRange = {
      min: Number(result?.aggregations?.min_price.value),
      max: Number(result?.aggregations?.max_price.value),
    }
    const products = (result?.items || []).map((product) =>
      formatProduct(product)
    )

    return {
      products,
      totalCount: result?.total_count || 0,
      totalPages:
        (result?.total_count || 0) > limit
          ? Math.ceil((result?.total_count || 0) / limit)
          : 1,
      aggregations: {
        productTypes: productTypesBuckets,
        tasteTags: tasteTagsBuckets,
        colorTags: colorTagsBuckets,
        facetTags: facetTagsBuckets,
        priceRange,
      },
    }
  } catch (error) {
    console.error('FF Services API error', error)
    return {
      products: [],
      totalCount: 0,
      totalPages: 1,
      aggregations: defaultAggregations,
    }
  }
}
